/** Staff app → portal tab: JWT in the hash (not query) so it never hits the server. */

export const APP_HANDOFF_HASH_KEY = 'gee_handoff'

export type AppHandoffTokens = {
  access_token: string
  expires_in: number
}

export function parseAppHandoff(href?: string): AppHandoffTokens | null {
  const raw = String(href ?? (typeof window !== 'undefined' ? window.location.href : '')).trim()
  if (!raw) return null
  try {
    const url = new URL(raw, 'http://local.invalid')
    if (!url.pathname.startsWith('/recruitment-portal')) return null
    const hash = url.hash.replace(/^#/, '')
    if (!hash) return null
    const params = new URLSearchParams(hash)
    const token = String(params.get(APP_HANDOFF_HASH_KEY) || '').trim()
    if (token.length < 20) return null
    const exp = Number(params.get('exp') || 3600)
    return {
      access_token: token,
      expires_in: Number.isFinite(exp) && exp > 0 ? exp : 3600,
    }
  } catch {
    return null
  }
}

export function stripAppHandoffHash(): void {
  if (typeof window === 'undefined') return
  try {
    const url = new URL(window.location.href)
    if (!url.hash.includes(APP_HANDOFF_HASH_KEY)) return
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}`)
  } catch {
    // ignore
  }
}
